import(/* webpackMode: "eager" */ "/codebuild/output/src1175232097/src/node_modules/@ant-design/v5-patch-for-react-19/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/src/app/[locale]/layout/handleUrlParams.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/src/app/[locale]/layout/restoreSession.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1175232097/src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/codebuild/output/src1175232097/src/src/app/layout/ApolloWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/src/components/Buttons/phoneLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/src/components/Header/navBarBrand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/src/components/Hotjar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/src/components/MainContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1175232097/src/src/components/TagCommander/index.tsx");
